module.exports = __webpack_public_path__ + "images/photoshoot3-7c1255ca193d3cb5de8ea539a82dc281.jpg";